import { SxProps, Theme } from '@mui/material';
import React, { useCallback } from 'react';
import { Card } from 'react-bootstrap';

import { CUSTOMIZABLE_ITEM_DEFAULT_LABEL_TEXT } from '../../constants/ui';
import Input from '../Input/Input';
import LightboxBackgroundImage from '../_mui/_components_/LightboxBackgroundImage';

import styles from './CustomizableItem.module.scss';

const itemImageSx: SxProps<Theme> = {
  flexShrink: 0,
  width: { xs: 80, sm: 100 },
  height: { xs: 80, sm: 100 },
  bgcolor: 'common.white',
  cursor: 'zoom-in',
};

interface ICustomizableItemProps {
  itemName: string;
  label?: string;
  value?: string;
  name?: string;
  error?: string;
  imageUrl: string;
  onChange?: (value: React.ChangeEvent<HTMLInputElement>) => void;
  isCustomizationRequired?: boolean;
}

const CustomizableItem: React.FC<ICustomizableItemProps> = ({
  itemName,
  label = CUSTOMIZABLE_ITEM_DEFAULT_LABEL_TEXT,
  value,
  imageUrl,
  onChange,
  name,
  isCustomizationRequired,
  error,
}) => {
  const handleInputChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      if (onChange) {
        onChange(e);
      }
    },
    [onChange],
  );

  return (
    <Card className={styles.container}>
      <Card.Body className={styles.itemContentContainer}>
        <div className={styles.info}>
          <LightboxBackgroundImage sx={itemImageSx} url={imageUrl} stopPropagation preventDefault />
          <p className={styles.name}>{itemName}</p>
        </div>
        <Input
          type="text"
          label={label}
          value={value || ''}
          name={name}
          onChange={handleInputChange}
          className={styles.input}
          error={error}
        />
      </Card.Body>
      {isCustomizationRequired && <span className={styles.requiredLabel}>* required</span>}
    </Card>
  );
};

export default CustomizableItem;
